import React, { useRef } from 'react'
import { chipImg, frameImg, frameVideo, intrudeImg, intrudeMBImg, promotionImg_01, promotionImg_02, videoBgImg, frameFif} from '../utils'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap';
import { animateWithGsap } from '../utils/animations';
import CardCarousel from './CardCarousel';
import Slogan from './Slogan.jsx'
export default function HowItWorks({ theme, setTheme, isMobile }){
  const videoRef = useRef();
  useGSAP(() => {
    // gsap.from('#chip', {
    //   scrollTrigger: {
    //     trigger: '#howItWorks',      // 整个区域都作为触发器
    //     start: 'top 80%',            // 区域顶部进入视口 80% 时
    //     toggleActions: 'restart none none none', // 每次向下滚动到此处都重新播放
    //   },
    //   opacity: 0,
    //   scale: 2,
    //   duration: 2,
    //   ease: 'power2.inOut'
    // });
    animateWithGsap('.g_fadeIn', {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power2.inOut'
    });
  }, []);

  return (
    <section id='howItWorks'  className="py-0 pb-0 sm:pb-24 bg-light" style={{background:`url(${videoBgImg}) no-repeat center bottom 0%`,backgroundSize: '100% 45%' }}>
      <div className="">
        {/* <div id="chip" className="flex-center w-full">
          <img src={promotionImg_01} alt="chip" className=" w-[100vw] h-auto sm:w-full sm:h-full" />
          <img src={promotionImg_02} alt="chip" className=" w-[100vw] h-auto sm:w-full sm:h-full" />
        </div> */}
        <Slogan isMobile={isMobile} ></Slogan>
        <div className="flex-center screen-max-width">
          <div className=' w-[calc(100vw-40px)] sm:w-full h-full rounded-md border-b-[1px] border-r-[1px] border-[#bdc7e9] border-opacity-20 p-10 shadow-[-2px_-2px_10px_rgba(0,0,0,0.1)] shadow-black/20 mt-6 sm:mt-24' style={{backgroundImage:'linear-gradient(to bottom, white,#f3f7ff ,#f2f6ff),linear-gradient(to left, white, #f2f6ff)'}}>
            <img src={isMobile?intrudeMBImg:intrudeImg} alt="chip" className=" w-[100vw] h-auto sm:w-full sm:h-full" />
          </div>
        </div>
        <div className='w-[calc(100vw-40px)] screen-max-width pb-6 pt-6 sm:pb-20 sm:pt-24' id='highlights'>
          <div id="title">
            <p className='text-xl sm:text-2xl font-bold text-[#333333]'>智能警示镜AI算法介绍</p>
            <p className="mt-2 text-sm sm:text-base text-[#5A5C5D]">
              百万级真实作业场景训练的AI模型，复杂工地/车间环境下仍能精准识别，为安全监管提供“可量化，可追溯”智能依据
            </p>
          </div>
        </div>
        <CardCarousel isMobile={isMobile} ></CardCarousel>
        <div id='videoShow' className='w-[calc(100vw-40px)] sm:block screen-max-width h-[7rem] pt-12 sm:pt-8'>
          <span className='text-xl sm:text-2xl font-bold text-[#333333]'>智能警示镜视频演示</span>
        </div>
        <div className="sm:mb-14 screen-max-width">
          <div className="relative h-full flex-center">
            <div className="overflow-hidden">
              <img 
                src={frameImg}
                alt="frame"
                className="bg-transparent relative z-10"
                style={{width: isMobile?'95%':'56%',margin: 'auto'}}
              />
            </div>
            <div className="mt-6 sm:mt-0 hiw-mb-video sm:hiw-video">
                {/* <video className="pointer-events-none" loop preload="none" muted autoPlay ref={videoRef}>
                  <source src={frameVideo} type="video/mp4" />
                </video> */}
                <img src={frameFif} style={{width:'100%',height:isMobile?'87%':'90%'}} alt="" />
              </div>
          </div>
        </div>
      </div>
    </section>
  )
}
